import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DinamicData, Cell } from '../../models/dinamic-data';
import { BackgroundprocessService } from '../../services/backgroundprocess.service';
import { Title } from '@angular/platform-browser';
import { Methods } from '../../shared/methods';

@Component({
  selector: 'app-backgroundprocess',
  templateUrl: './backgroundprocess.component.html',
  styleUrls: ['./backgroundprocess.component.css']
})
export class BackgroundprocessComponent implements OnInit {

  public mtds: Methods = new Methods();

  public filtertype = 'All';
  public loading = false;
  public purchasp: DinamicData = new DinamicData(
    ['Id', 'Type', 'Description', 'Rep', 'Created At', 'Started At', 'Finished At', 'Status', 'Actions']
  );

  public campoBusqueda = '';
  public paginaActual = 1;
  public itemsPorPagina = '10';
  public totalItems = 0;
  public totalPaginas = 1;

  constructor(private _router: Router, private _service: BackgroundprocessService, private titleService: Title,) {
    this.titleService.setTitle( 'Background Processes' );
  }

  ngOnInit() {
    this.getList();
  }

  actions(e) {
    console.log("e => ", e);
    switch (e.action) {
      case "show":
          if(e.id && e.id.downloadFile){
            window.open(e.id.downloadFile);
          }
        break;
      
 

      default:
        break;
    }
  }


  getList(e = null) {
    this.loading = true;
    this._service.list(
      e !== null ? e.page : 1,
      e !== null ? e.perPage : 10,
      e !== null ? (this.campoBusqueda = e.search) : (this.campoBusqueda = ''),
      this.filtertype).subscribe(
      r => {
        console.log(r);
        if (r.code === 400 && r.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (r.status === 'success') {

          this.paginaActual = Number(r.page_actual);
          this.itemsPorPagina = String(r.items_per_page);
          this.totalItems = Number(r.total_items_count);
          this.totalPaginas = Number(r.total_pages);

          this.purchasp.rows = [];

          for (let element of r.data) {

            let actionButtons = [];
            if(element.isPrivate > 0 && element.status == 'Completed' && element.downloadFile)
              actionButtons.push({
                icon: "file_download",
                title: "Detail",
                action: "show",
                color: "info",
                value: element,
              });

            this.purchasp.rows.push(
              [
                new Cell(element.id),
                new Cell(element.type),
                new Cell(element.descripcion),
                new Cell(element.rep ? element.rep.name + ' ' + element.rep.surname : ''),
                new Cell(element.createdAt,{ type: 'full-date' }),
                new Cell(element.startedAt, { type: 'full-date' }),
                new Cell(element.finishedAt, { type: 'full-date' }),
                new Cell(element.status, {class: "fw-bold", color: (String(element.status).includes('Waiting') ? 'danger' : (String(element.status).includes('Running') ? 'warning' : 'success'))}),
                new Cell(actionButtons, { type: "actions", class: "white-space-nowrap" })
              ]
            )
          }
        }

        this.loading = false;

      }, err => {
        this.loading = true;
      }
    );
  }

}
